/* eslint-disable vue/require-v-for-key */
<template>
    <!-- 错题辅导error_counseling -->
    <div class="container">
        <Header/>
        <div class="content">
            <div class="title">错题辅导</div>
            <div class="correction">
                <div class="shop" v-for="(item,index) in dataArr" :key="index">
          <span class="subject_logo" v-if="item.name == '智能英语'" style="background: #0079FE">
            <i class="iconfont">&#xe63a;</i>
          </span>
          <span class="subject_logo" v-if="item.name == '暑期英语'" style="background: #0079FE">
            <i class="iconfont">&#xe63a;</i>
          </span>
                    <span class="subject_logo" v-if="item.name == '智能科学'" style="background: #E95513">
            <i class="iconfont">&#xe62f;</i>
          </span>
                    <span class="subject_logo" v-if="item.name == '智能物理'" style="background: #30BF93">
            <i class="iconfont">&#xe634;</i>
          </span>
                    <span class="subject_logo" v-if="item.name == '智能语文'" style="background: #644FE5">
            <i class="iconfont">&#xe635;</i>
          </span>
                    <span class="subject_logo" v-if="item.name == '暑期语文'" style="background: #644FE5">
            <i class="iconfont">&#xe635;</i>
          </span>
                    <span class="subject_logo" v-if="item.name == '智能化学'" style="background: #FFBC00">
            <i class="iconfont">&#xe63d;</i>
          </span>
                    <span class="subject_logo" v-if="item.name == '智能生物'" style="background: #70B603">
            <i class="iconfont">&#xe633;</i>
          </span>
                    <span class="subject_logo" v-if="item.name == '智能数学'" style="background: #333333">
            <i class="iconfont">&#xe640;</i>
          </span>
                    <span class="subject_logo" v-if="item.name == '强基数学'" style="background: #333333">
            <i class="iconfont">&#xe640;</i>
          </span>
                    <span class="subject_logo" v-if="item.name == '暑期数学'" style="background: #333333">
            <i class="iconfont">&#xe640;</i>
          </span>
                    <span class="subject_logo" v-if="item.name == '智能地理'" style="background: #363BA9">
            <i class="iconfont">&#xe627;</i>
          </span>
                    <span class="subject_logo" v-if="item.name == '智能历史'" style="background: #797979">
            <i class="iconfont">&#xe62a;</i>
          </span>
                    <span class="subject_logo" v-if="item.name == '智能政治'" style="background: #E50012">
            <i class="iconfont">&#xe639;</i>
          </span>

                    <div class="subtitle_name">
                        <span>{{ item.name | filtersTextChange}}</span>
                    </div>
                    <div class="errNumber">
                        <span>待订正的错题数{{ item.wrongNum }}</span>
                    </div>
                    <div class="modify" v-if="item.wrongNum!=0" @click="setParams(item.id)">
                        <span>错题订正</span>
                    </div>
                </div>
            </div>
        </div>
        <Footer/>
    </div>
</template>

<script>
    import api from "../axios/interface";
    import Header from "../components/common/Header";
    import Footer from "../components/common/Footer";

    export default {
        name: "error_counseling",
        data() {
            return {
                dataArr: [],
                subjectId: ""
            };
        },

        mounted() {
            this.getWrongStatistics();
        },

        methods: {
            setParams(id) {
                this.subjectId = id;
                this.confirm();
            },

            // 获取错题本数据统计接口
            getWrongStatistics() {
                let that = this;
                this.$axios
                    .get(api.GetWrongStatistics, {}, {hideMessage: true})
                    .then(res => {
                        that.dataArr = res.result.data;
                    })
                    .catch(res => {
                    });
            },

            confirm() {
                //点击跳转函数
                this.$router.push({
                    path: "/errorContent", //跳转路由
                    query: {
                        subjectId: this.subjectId
                    }
                });
            }
        },
        components: {
            // eslint-disable-next-line prettier/prettier
            Header: Header,
            Footer: Footer
        },
        filters: {
            filtersTextChange: function (val) {
                let nameStr = val.substr(2, 2);
                //return nameStr;
                return val;
            }
        }
    };
</script>

<style lang="less" scoped>
    .header {
        background: #fff;
    }

    .content {
        font-family: PingFangSC-Regular, PingFang SC;
        width: 1056px;
        margin: 90px 50px 0 50px;
        height: 614px;
        text-align: center;
        border-radius: 20px;
        background: #fff;
        display: flex;
        flex-direction: column;
    }

    .content .title {
        width: 1056px;
        height: 37px;
        line-height: 37px;
        font-size: 32px;
        padding-top: 66px;
        color: #4d4d4d;
        text-align: center;
    }

    .correction {
        width: 1000px;
        height: auto;
        display: flex;
        flex-direction: row;
        margin-top: 45px;
        margin-left: 48px;
        flex-flow: wrap;
        background: #fff;

        .shop {
            width: 184px;
            height: 200px;
            text-align: center;
            border-radius: 5px;
            background: #eeeeee;
            margin-right: 10px;
            margin-bottom: 24px;

            .subject_logo {
                margin-top: 16px;
                display: inline-block;
                padding: 8px;
                border-radius: 50%;

                i {
                    font-size: 30px;
                    color: #ffffff;
                }
            }

            .subtitle_name {
                width: 100%;
                height: 27px;
                color: #4d4d4d;
                font-weight: 500;

                font-size: 24px;
                margin-top: 12px;
            }

            .errNumber {
                width: 100%;
                color: #666666;
                font-size: 14px;
                line-height: 20px;
                margin-top: 34px;
            }

            .modify {
                width: 100%;
                color: #333333;
                cursor: pointer;
                font-weight: 600;
                font-size: 16px;
                line-height: 24px;
                margin-top: 8px;
            }
        }
    }
</style>
<style lang="less">
    .cuoti_alert {
        .el-dialog {
            border-radius: 4px;

            .el-dialog__header {
                padding: 32px 32px 0 32px;
                color: #333;

                .el-dialog__title {
                    font-weight: 600;
                }
            }

            .el-dialog__body {
                padding: 12px 32px;
                line-height: 22px;
                color: #666;
            }

            .el-dialog__footer {
                padding: 12px 32px 24px;

                .btn-inblock {
                    background-color: #0079fe;
                    color: #fff;
                    cursor: pointer;
                    font-size: 14px;
                    padding: 5px 16px;
                    border-radius: 4px;
                }
            }
        }
    }
</style>
